"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompanyServicesStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
const lodash_1 = require("lodash");
// Alapértelmezett értékek a detaildService számára
const defaultDetaildService = {
    id: null,
    name: "",
    description: "",
    coll: [],
    duration: 15,
    price: 0,
    onlinePrice: 0,
    serviceTypeId: 1,
    serviceBayType: 1,
    runflat: false,
    serviceSubType: [],
    assignedLocations: [],
};
exports.useCompanyServicesStore = (0, pinia_1.defineStore)("companyServicesStore", {
    state: () => ({
        services: [],
        detaildService: { ...defaultDetaildService },
    }),
    getters: {
        allServices(state) {
            return state.services;
        },
        isActive(state) {
            return (service) => (0, lodash_1.isArray)(service.assignedLocations) &&
                service.assignedLocations.length > 0;
        },
    },
    actions: {
        async fetchServices(companyId) {
            this.services = [];
            try {
                const response = await (0, fetch_1.default)("/api/company-get-all-services", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ companyId }),
                });
                if (response.error) {
                    throw new Error(i18n_1.default.trans("backend_services_error", "No services found!", "backend_services"));
                }
                response.forEach((item) => {
                    this.services.push(item);
                });
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
        async fetchDetailedService(id) {
            this.detaildService = { ...defaultDetaildService }; // Visszaállítás alapértelmezett értékekre
            try {
                const response = await (0, fetch_1.default)(`/api/services/get/${id}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                });
                if (response.error) {
                    throw new Error(i18n_1.default.trans("backend_service_error", "No service found!", "backend_services"));
                }
                this.detaildService = {
                    id: response.id,
                    name: response.name,
                    description: response.description,
                    coll: response.coll,
                    duration: response.duration,
                    price: response.price,
                    onlinePrice: response.online_price,
                    serviceTypeId: response.serviceTypeId,
                    serviceBayType: response.serviceBayType,
                    runflat: response.runflat,
                    serviceSubType: response.serviceSubType,
                    assignedLocations: response.assignedLocations,
                };
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        },
        clearDetaildService() {
            //console.log({ ...defaultDetaildService });
            this.detaildService = structuredClone(defaultDetaildService); // Reset alapértelmezett értékekre
        },
        async saveService(service, selectedCompanyId) {
            try {
                const response = await (0, fetch_1.default)("api/services/save", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        service: service,
                        companyId: selectedCompanyId,
                    }),
                });
                if (typeof response.success !== "undefined" &&
                    response.success === true) {
                    return { success: true, id: response.id };
                }
                else {
                    return {
                        success: false,
                        error: i18n_1.default.trans("backend_service_save_error", "Something went wrong when saving the event!", "backend"),
                    };
                }
            }
            catch (error) {
                console.error(error);
                return { success: false, error: "Unexpected error occurred." };
            }
        },
        async deleteService(serviceId) {
            try {
                const response = await (0, fetch_1.default)("api/services/delete/" + serviceId, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                });
                if (typeof response.success !== "undefined" &&
                    response.success === true) {
                    return { success: true };
                }
                else {
                    return {
                        success: false,
                        error: i18n_1.default.trans("backend_service_save_error", "Something went wrong when deleting the event!", "backend"),
                    };
                }
            }
            catch (error) {
                return { success: false, error: "Unexpected error occurred." };
            }
        },
    },
});
